import type { StaticSharedField } from './types';
import {
  ERR_TYPE_REQUIRED,
  ERR_TYPE_STR_LONG,
  ERR_TYPE_STR_SHORT,
  FIELD_TYPE_TXT,
} from '/business/shared/components/questions/helper/fieldEnums';

export default function useMakeProductDescription(): StaticSharedField {
  return {
    type: FIELD_TYPE_TXT,
    label: 'Product description',
    propName: 'product_description',
    element: 'product_description',
    validation: [
      {
        rule: ERR_TYPE_REQUIRED,
        errCode: 'ERRNOPRODUCTDESCRIPTION',
        errStr: 'Please enter a product description',
      },
      {
        rule: ERR_TYPE_STR_SHORT,
        errCode: 'ERRPRODUCTDESCRIPTIONTOOSHORT',
        errStr: 'Product description name too short',
        value: 3,
      },
      {
        rule: ERR_TYPE_STR_LONG,
        errCode: 'ERRPRODUCTDESCRIPTIONTOOLONG',
        errStr: 'Product description name too long',
        value: 300,
      },
    ],
  };
}
